module.exports = __webpack_public_path__ + "static/media/two.e0fb70e0.png";